//@flow
import React from 'react';
import { Image } from 'components/atoms/image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CallToAction } from 'components/atoms/callToAction';
import { RouteNames } from 'router';
import { RouteUtil } from 'utils/RouteUtil';
import { withRouter } from 'react-router-dom';
//eslint-disable-next-line
import styles from "./styles.scss";
import PastEventsDesktop from 'assets/images/PastEventsDesktop.jpg';

const PastEventsBanner = (props) => {

  const handleSeeAll = (props) => {
    RouteUtil.setRouteChange(props, RouteNames.pastMusicEvents);
  };

  return (
    <div className={'main-section'}>
      <Row className={'main-row'}>
        <Col
          className={'left-section'}
          xs={{ span: 11 }}
          md={{ span: 3, offset: 0 }}
        >
          <h3 className={'subHeadingClassName'}> Featured </h3>
          <h1 className={'headingClassName'}> Past Events </h1>
          <div>
            <CallToAction
                mode={'dark'}
                text={'SEE ALL'}
                onClick={() => handleSeeAll(props)}
                className={'learn-more'}
            />
          </div>
        </Col>
        <Col md={{ span: 8, offset: 1 }} className={'right-section'}>
          <Image
            src={PastEventsDesktop}
            alt={'past events banner'}
            className={'foundation-image'}
          />
        </Col>
      </Row>
    </div>
  );
};

export default withRouter(PastEventsBanner);